import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '../../app.service';
import { ICropperDialogData } from './cropper-dialog.interface';

@Component({
    selector: 'app-cropper-dialog',
    templateUrl: './cropper-dialog.component.html',
    styleUrls: ['./cropper-dialog.component.css'],
})
export class CropperDialogComponent {
    readonly appService = inject(AppService);
    readonly dialogRef = inject(MatDialogRef<CropperDialogComponent>);
    readonly data: ICropperDialogData = inject(MAT_DIALOG_DATA);

    /**
     * Первый шаг
     */
    firstStep: boolean = true;

    /**
     * Второй шаг
     */
    twoStep: boolean = false;

    /**
     * Поворот изображения
     */
    canvasRotation: number = 0;

    /**
     * Данные картинок
     */
    dataImages = {
        box: null,
        round: null,
    };

    /**
     * Переход от первого шага ко второму
     */
    switchToSecond() {
        this.firstStep = false;
        this.twoStep = true;
    }

    /**
     * Закрытие диалога, возвращение данных
     */
    save() {
        this.dialogRef.close({
            save: true,
            box: this.dataImages.box ?? null,
            round: this.dataImages.round ?? null,
        });
    }

    /**
     * Закрытие диалога
     */
    close() {
        this.dialogRef.close({ save: false });
    }

    /**
     * Возврат к предыдущему шагу
     */
    backStep() {
        this.firstStep = true;
        this.twoStep = false;
    }

    /**
     * Повернуть картинку
     */
    rotateImage() {
        this.canvasRotation++;
    }
}
